import dayjs from "dayjs";
import "dayjs/locale/it";
import config from "../settings/config";
import { getAuthToken } from "./authStorage";

// The FREE Programs a member can enrol in, as the backend offers them: only the
// ones still open for enrolment (this week's while its deadline hasn't passed,
// then the next scheduled ones). Shared by the Free Programme screen and the
// routing right after onboarding, so both agree on whether there is an offer.

// The two closest programs are offered side by side (client decision, 17/09).
export const MAX_START_OPTIONS = 2;

export const isRouteEligibleForFreeStart = (row) =>
  row?.route?.free === true || row?.route?.is_default_for_free === true;

// "YYYY-MM-DD" from the route start. Only the date part is read: a full
// timestamp ("…T00:00:00.000Z") parsed in the device's timezone would show, and
// send, the previous day west of UTC.
export const routeStartKey = (row) =>
  String(row?.route?.start ?? "").slice(0, 10);

// The preparation week opens seven days before the start. Until then the member
// stays a Guest (client decision, 17/09; the backend's
// MasterClubSubscription::FREE_PREPARATION_DAYS).
export const FREE_PREPARATION_DAYS = 7;

/** Whether a program starting on `start` is still more than a week away. */
export const startsAfterPreparationWeek = (start, today = dayjs()) =>
  dayjs(String(start ?? "").slice(0, 10)).diff(
    dayjs(today).startOf("day"),
    "day",
  ) > FREE_PREPARATION_DAYS;

/**
 * "lunedì 28 settembre": a program's start as the copy says it, mid-sentence
 * (the Italian locale capitalises day and month names). Date part only, like
 * routeStartKey.
 */
export const freeProgramStartLabel = (start) =>
  dayjs(String(start ?? "").slice(0, 10))
    .locale("it")
    .format("dddd D MMMM")
    .toLowerCase();

/**
 * The offer from a subscriber-routes response.
 * @returns {{options: object[], canStart: boolean}} options soonest first, at
 *   most MAX_START_OPTIONS; canStart is false once the member's FREE trials are
 *   used up (true when the backend doesn't say).
 */
export const buildFreeProgramOffer = (rows) => {
  const options = (Array.isArray(rows) ? rows : [])
    .filter(isRouteEligibleForFreeStart)
    .sort((a, b) => routeStartKey(a).localeCompare(routeStartKey(b)))
    .slice(0, MAX_START_OPTIONS);

  const first = options[0];
  const canStart =
    !!first &&
    (first.user_free_routes === undefined ||
      first.max_free_routes === undefined ||
      first.user_free_routes < first.max_free_routes);

  return { options, canStart };
};

export const fetchFreeProgramOffer = async () => {
  const res = await fetch(
    `${config.env[config.env.mode].url}/api/master-club-route/subscriber-routes`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getAuthToken()}`,
      },
    },
  );

  if (!res.ok) throw new Error("Errore nel caricamento dei percorsi.");

  return buildFreeProgramOffer(await res.json());
};
